import { Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import dayjs from 'dayjs';
import { HedgePlanTermReportModel } from '../../../../Generated/Commodity-Management-Api';

interface HedgePlanVolumeTableProps {
  periodLabel: string;
  report: HedgePlanTermReportModel;
}

function formatVolume(volume: number): string {
  return Math.round(volume).toLocaleString('en-US');
}

export default function HedgePlanVolumeTable(props: HedgePlanVolumeTableProps) {
  const { periodLabel, report } = props;
  const volumeSeries = report.volumeSeries ?? [];
  const hasAdjustment = report.budgetAdjustment !== null && report.budgetAdjustment !== undefined && report.budgetAdjustment !== 0;

  if (!report.volumeUnit || volumeSeries.length === 0) {
    return null;
  }

  return (
    <Paper variant="outlined" sx={{ marginTop: 2, overflowX: 'auto' }}>
      <Table size="small" aria-label={`${periodLabel} budget`}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>
              {periodLabel} budget{report.isWeightedByVolume ? ' · price curve weighted' : ''}
            </TableCell>
            {volumeSeries.map((point) => (
              <TableCell key={`${point.contractYear}-${point.contractMonth}`} align="right" sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>
                {dayjs(new Date(point.contractYear ?? 0, (point.contractMonth ?? 1) - 1, 1)).format('MMM YY')}
              </TableCell>
            ))}
            <TableCell align="right" sx={{ fontWeight: 700 }}>Total</TableCell>
            {hasAdjustment && (
              <>
                <TableCell align="right" sx={{ fontWeight: 700 }}>Adjustment</TableCell>
                <TableCell align="right" sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Adjusted Total</TableCell>
              </>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell />
            {volumeSeries.map((point) => (
              <TableCell key={`${point.contractYear}-${point.contractMonth}`} align="right">{formatVolume(point.volume ?? 0)}</TableCell>
            ))}
            <TableCell align="right">
              {report.budgetedVolume === null || report.budgetedVolume === undefined ? 'Incomplete' : formatVolume(report.budgetedVolume)}
            </TableCell>
            {hasAdjustment && (
              <>
                <TableCell align="right">{`${(report.budgetAdjustment as number) > 0 ? '+' : ''}${formatVolume(report.budgetAdjustment as number)}`}</TableCell>
                <TableCell align="right">{report.totalVolume === null || report.totalVolume === undefined ? 'Incomplete' : formatVolume(report.totalVolume)}</TableCell>
              </>
            )}
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  );
}
